// Extracts valid department IDs from a filter framework department value,
// dropping empty/null/"all" entries. The Filter framework returns either a
// single object or an array depending on multiSelect config.
export const getValidDepartmentIds = (departmentValue) => {
	if (!departmentValue) return [];
	const depts = Array.isArray(departmentValue) ? departmentValue : [departmentValue];
	return depts
		.filter((d) => d?.id && d.id !== "" && d.id !== "all")
		.map((d) => d.id);
};
